//# sourceMappingURL=msg.mjs.map
/// <reference types="./msg.d.mts" />
import * as $auth0 from "../../auth0_client/auth0/client.mjs";
import * as $auth0_user from "../../auth0_client/auth0/client/user.mjs";
import * as $ai_config from "../../data_types/data/ai_config.mjs";
import * as $connection from "../../data_types/data/auth/connection.mjs";
import * as $invitation from "../../data_types/data/auth/invitation.mjs";
import * as $organization from "../../data_types/data/auth/organization.mjs";
import * as $role from "../../data_types/data/auth/role.mjs";
import * as $user_id from "../../data_types/data/auth/user_id.mjs";
import * as $data_point from "../../data_types/data/data_point.mjs";
import * as $data_source from "../../data_types/data/data_source.mjs";
import * as $wss_connected from "../../data_types/data/ephemeral/wss_connected.mjs";
import * as $llm_capacity from "../../data_types/data/llm_capacity.mjs";
import * as $maintenance from "../../data_types/data/maintenance.mjs";
import * as $metrics from "../../data_types/data/metrics.mjs";
import * as $page from "../../data_types/data/page.mjs";
import * as $project from "../../data_types/data/project.mjs";
import * as $project_file from "../../data_types/data/project_file.mjs";
import * as $proposal from "../../data_types/data/proposal.mjs";
import * as $proposal_element from "../../data_types/data/proposal_element.mjs";
import * as $answer from "../../data_types/data/proposal_element/answer.mjs";
import * as $qualification_matrix from "../../data_types/data/qualification_matrix.mjs";
import * as $remote from "../../data_types/data/remote.mjs";
import * as $tag from "../../data_types/data/tag.mjs";
import * as $translate from "../../data_types/data/translate.mjs";
import * as $language from "../../data_types/data/translate/language.mjs";
import * as $user from "../../data_types/data/user.mjs";
import * as $weaviate from "../../data_types/data/weaviate.mjs";
import * as $dict from "../../gleam_stdlib/gleam/dict.mjs";
import * as $option from "../../gleam_stdlib/gleam/option.mjs";
import * as $uri from "../../gleam_stdlib/gleam/uri.mjs";
import * as $duration from "../../gleam_time/gleam/time/duration.mjs";
import * as $toast from "../../redraw_toastify/toastify/toast.mjs";
import * as $assoc from "../../tiamat/gleam/assoc.mjs";
import * as $llm_usage from "../data/llm_usage.mjs";
import * as $dataset from "../elements/charts/dataset.mjs";
import { CustomType as $CustomType } from "../gleam.mjs";

export class ApplicationChangedRoute extends $CustomType {
  constructor(route) {
    super();
    this.route = route;
  }
}
export const Msg$ApplicationChangedRoute = (route) =>
  new ApplicationChangedRoute(route);
export const Msg$isApplicationChangedRoute = (value) =>
  value instanceof ApplicationChangedRoute;
export const Msg$ApplicationChangedRoute$route = (value) => value.route;
export const Msg$ApplicationChangedRoute$0 = (value) => value.route;

export class Auth0 extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}
export const Msg$Auth0 = ($0) => new Auth0($0);
export const Msg$isAuth0 = (value) => value instanceof Auth0;
export const Msg$Auth0$0 = (value) => value[0];

export class AuthStateChanged extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}
export const Msg$AuthStateChanged = ($0) => new AuthStateChanged($0);
export const Msg$isAuthStateChanged = (value) =>
  value instanceof AuthStateChanged;
export const Msg$AuthStateChanged$0 = (value) => value[0];

/**
 * Who the caller is in our own schema; the token only names an account.
 */
export class ApiReturnedUserIdentity extends $CustomType {
  constructor(user_id) {
    super();
    this.user_id = user_id;
  }
}
export const Msg$ApiReturnedUserIdentity = (user_id) =>
  new ApiReturnedUserIdentity(user_id);
export const Msg$isApiReturnedUserIdentity = (value) =>
  value instanceof ApiReturnedUserIdentity;
export const Msg$ApiReturnedUserIdentity$user_id = (value) => value.user_id;
export const Msg$ApiReturnedUserIdentity$0 = (value) => value.user_id;

export class ContentLibrary extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}
export const Msg$ContentLibrary = ($0) => new ContentLibrary($0);
export const Msg$isContentLibrary = (value) => value instanceof ContentLibrary;
export const Msg$ContentLibrary$0 = (value) => value[0];

export class AiConfig extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}
export const Msg$AiConfig = ($0) => new AiConfig($0);
export const Msg$isAiConfig = (value) => value instanceof AiConfig;
export const Msg$AiConfig$0 = (value) => value[0];

export class UserSelectedOrganization extends $CustomType {
  constructor(organization) {
    super();
    this.organization = organization;
  }
}
export const Msg$UserSelectedOrganization = (organization) =>
  new UserSelectedOrganization(organization);
export const Msg$isUserSelectedOrganization = (value) =>
  value instanceof UserSelectedOrganization;
export const Msg$UserSelectedOrganization$organization = (value) =>
  value.organization;
export const Msg$UserSelectedOrganization$0 = (value) => value.organization;

export class OrganizationSetup extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}
export const Msg$OrganizationSetup = ($0) => new OrganizationSetup($0);
export const Msg$isOrganizationSetup = (value) =>
  value instanceof OrganizationSetup;
export const Msg$OrganizationSetup$0 = (value) => value[0];

export class MaintenanceMode extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}
export const Msg$MaintenanceMode = ($0) => new MaintenanceMode($0);
export const Msg$isMaintenanceMode = (value) =>
  value instanceof MaintenanceMode;
export const Msg$MaintenanceMode$0 = (value) => value[0];

export class DataSources extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}
export const Msg$DataSources = ($0) => new DataSources($0);
export const Msg$isDataSources = (value) => value instanceof DataSources;
export const Msg$DataSources$0 = (value) => value[0];

export class Organizations extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}
export const Msg$Organizations = ($0) => new Organizations($0);
export const Msg$isOrganizations = (value) => value instanceof Organizations;
export const Msg$Organizations$0 = (value) => value[0];

export class Dashboard extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}
export const Msg$Dashboard = ($0) => new Dashboard($0);
export const Msg$isDashboard = (value) => value instanceof Dashboard;
export const Msg$Dashboard$0 = (value) => value[0];

export class Project extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}
export const Msg$Project = ($0) => new Project($0);
export const Msg$isProject = (value) => value instanceof Project;
export const Msg$Project$0 = (value) => value[0];

export class Proposal extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}
export const Msg$Proposal = ($0) => new Proposal($0);
export const Msg$isProposal = (value) => value instanceof Proposal;
export const Msg$Proposal$0 = (value) => value[0];

export class ApplicationRequestedToDisplayToast extends $CustomType {
  constructor(level, message) {
    super();
    this.level = level;
    this.message = message;
  }
}
export const Msg$ApplicationRequestedToDisplayToast = (level, message) =>
  new ApplicationRequestedToDisplayToast(level, message);
export const Msg$isApplicationRequestedToDisplayToast = (value) =>
  value instanceof ApplicationRequestedToDisplayToast;
export const Msg$ApplicationRequestedToDisplayToast$level = (value) =>
  value.level;
export const Msg$ApplicationRequestedToDisplayToast$0 = (value) => value.level;
export const Msg$ApplicationRequestedToDisplayToast$message = (value) =>
  value.message;
export const Msg$ApplicationRequestedToDisplayToast$1 = (value) =>
  value.message;

export class ApiStartedLoadingRoles extends $CustomType {}
export const Msg$ApiStartedLoadingRoles = () => new ApiStartedLoadingRoles();
export const Msg$isApiStartedLoadingRoles = (value) =>
  value instanceof ApiStartedLoadingRoles;

export class ApiErroredRoles extends $CustomType {
  constructor(content) {
    super();
    this.content = content;
  }
}
export const Msg$ApiErroredRoles = (content) => new ApiErroredRoles(content);
export const Msg$isApiErroredRoles = (value) =>
  value instanceof ApiErroredRoles;
export const Msg$ApiErroredRoles$content = (value) => value.content;
export const Msg$ApiErroredRoles$0 = (value) => value.content;

export class ApiReturnedRoles extends $CustomType {
  constructor(roles) {
    super();
    this.roles = roles;
  }
}
export const Msg$ApiReturnedRoles = (roles) => new ApiReturnedRoles(roles);
export const Msg$isApiReturnedRoles = (value) =>
  value instanceof ApiReturnedRoles;
export const Msg$ApiReturnedRoles$roles = (value) => value.roles;
export const Msg$ApiReturnedRoles$0 = (value) => value.roles;

export class ApiStartedLoadingConnections extends $CustomType {}
export const Msg$ApiStartedLoadingConnections = () =>
  new ApiStartedLoadingConnections();
export const Msg$isApiStartedLoadingConnections = (value) =>
  value instanceof ApiStartedLoadingConnections;

export class ApiErroredConnections extends $CustomType {
  constructor(content) {
    super();
    this.content = content;
  }
}
export const Msg$ApiErroredConnections = (content) =>
  new ApiErroredConnections(content);
export const Msg$isApiErroredConnections = (value) =>
  value instanceof ApiErroredConnections;
export const Msg$ApiErroredConnections$content = (value) => value.content;
export const Msg$ApiErroredConnections$0 = (value) => value.content;

export class ApiReturnedConnections extends $CustomType {
  constructor(connections) {
    super();
    this.connections = connections;
  }
}
export const Msg$ApiReturnedConnections = (connections) =>
  new ApiReturnedConnections(connections);
export const Msg$isApiReturnedConnections = (value) =>
  value instanceof ApiReturnedConnections;
export const Msg$ApiReturnedConnections$connections = (value) =>
  value.connections;
export const Msg$ApiReturnedConnections$0 = (value) => value.connections;

export class Weaviate extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}
export const Msg$Weaviate = ($0) => new Weaviate($0);
export const Msg$isWeaviate = (value) => value instanceof Weaviate;
export const Msg$Weaviate$0 = (value) => value[0];

export class Sitemap extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}
export const Msg$Sitemap = ($0) => new Sitemap($0);
export const Msg$isSitemap = (value) => value instanceof Sitemap;
export const Msg$Sitemap$0 = (value) => value[0];

export class LabelTranslations extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}
export const Msg$LabelTranslations = ($0) => new LabelTranslations($0);
export const Msg$isLabelTranslations = (value) =>
  value instanceof LabelTranslations;
export const Msg$LabelTranslations$0 = (value) => value[0];

export class LlmCapacity extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}
export const Msg$LlmCapacity = ($0) => new LlmCapacity($0);
export const Msg$isLlmCapacity = (value) => value instanceof LlmCapacity;
export const Msg$LlmCapacity$0 = (value) => value[0];

export class UserRequestedSitemapParse extends $CustomType {
  constructor(url) {
    super();
    this.url = url;
  }
}
export const Sitemap$UserRequestedSitemapParse = (url) =>
  new UserRequestedSitemapParse(url);
export const Sitemap$isUserRequestedSitemapParse = (value) =>
  value instanceof UserRequestedSitemapParse;
export const Sitemap$UserRequestedSitemapParse$url = (value) => value.url;
export const Sitemap$UserRequestedSitemapParse$0 = (value) => value.url;

export class UserClearedSitemap extends $CustomType {}
export const Sitemap$UserClearedSitemap = () => new UserClearedSitemap();
export const Sitemap$isUserClearedSitemap = (value) =>
  value instanceof UserClearedSitemap;

export class ApiReturnedSitemapUrls extends $CustomType {
  constructor(urls) {
    super();
    this.urls = urls;
  }
}
export const Sitemap$ApiReturnedSitemapUrls = (urls) =>
  new ApiReturnedSitemapUrls(urls);
export const Sitemap$isApiReturnedSitemapUrls = (value) =>
  value instanceof ApiReturnedSitemapUrls;
export const Sitemap$ApiReturnedSitemapUrls$urls = (value) => value.urls;
export const Sitemap$ApiReturnedSitemapUrls$0 = (value) => value.urls;

export class ApiReturnedRateLimits extends $CustomType {
  constructor(rate_limits) {
    super();
    this.rate_limits = rate_limits;
  }
}
export const LlmCapacity$ApiReturnedRateLimits = (rate_limits) =>
  new ApiReturnedRateLimits(rate_limits);
export const LlmCapacity$isApiReturnedRateLimits = (value) =>
  value instanceof ApiReturnedRateLimits;
export const LlmCapacity$ApiReturnedRateLimits$rate_limits = (value) =>
  value.rate_limits;
export const LlmCapacity$ApiReturnedRateLimits$0 = (value) => value.rate_limits;

export class ApiReturnedOrganizationsActivity extends $CustomType {
  constructor(months, activity) {
    super();
    this.months = months;
    this.activity = activity;
  }
}
export const LlmCapacity$ApiReturnedOrganizationsActivity = (months, activity) =>
  new ApiReturnedOrganizationsActivity(months, activity);
export const LlmCapacity$isApiReturnedOrganizationsActivity = (value) =>
  value instanceof ApiReturnedOrganizationsActivity;
export const LlmCapacity$ApiReturnedOrganizationsActivity$months = (value) =>
  value.months;
export const LlmCapacity$ApiReturnedOrganizationsActivity$0 = (value) =>
  value.months;
export const LlmCapacity$ApiReturnedOrganizationsActivity$activity = (value) =>
  value.activity;
export const LlmCapacity$ApiReturnedOrganizationsActivity$1 = (value) =>
  value.activity;

export class ApiReturnedLlmUsage extends $CustomType {
  constructor(environment, days, usage) {
    super();
    this.environment = environment;
    this.days = days;
    this.usage = usage;
  }
}
export const LlmCapacity$ApiReturnedLlmUsage = (environment, days, usage) =>
  new ApiReturnedLlmUsage(environment, days, usage);
export const LlmCapacity$isApiReturnedLlmUsage = (value) =>
  value instanceof ApiReturnedLlmUsage;
export const LlmCapacity$ApiReturnedLlmUsage$environment = (value) =>
  value.environment;
export const LlmCapacity$ApiReturnedLlmUsage$0 = (value) => value.environment;
export const LlmCapacity$ApiReturnedLlmUsage$days = (value) => value.days;
export const LlmCapacity$ApiReturnedLlmUsage$1 = (value) => value.days;
export const LlmCapacity$ApiReturnedLlmUsage$usage = (value) => value.usage;
export const LlmCapacity$ApiReturnedLlmUsage$2 = (value) => value.usage;

export class ApiReturnedLlmUsageByOrg extends $CustomType {
  constructor(environment, days, usage) {
    super();
    this.environment = environment;
    this.days = days;
    this.usage = usage;
  }
}
export const LlmCapacity$ApiReturnedLlmUsageByOrg = (environment, days, usage) =>
  new ApiReturnedLlmUsageByOrg(environment, days, usage);
export const LlmCapacity$isApiReturnedLlmUsageByOrg = (value) =>
  value instanceof ApiReturnedLlmUsageByOrg;
export const LlmCapacity$ApiReturnedLlmUsageByOrg$environment = (value) =>
  value.environment;
export const LlmCapacity$ApiReturnedLlmUsageByOrg$0 = (value) =>
  value.environment;
export const LlmCapacity$ApiReturnedLlmUsageByOrg$days = (value) => value.days;
export const LlmCapacity$ApiReturnedLlmUsageByOrg$1 = (value) => value.days;
export const LlmCapacity$ApiReturnedLlmUsageByOrg$usage = (value) =>
  value.usage;
export const LlmCapacity$ApiReturnedLlmUsageByOrg$2 = (value) => value.usage;

export class ApiErroredMigrations extends $CustomType {
  constructor(org_id, error) {
    super();
    this.org_id = org_id;
    this.error = error;
  }
}
export const Weaviate$ApiErroredMigrations = (org_id, error) =>
  new ApiErroredMigrations(org_id, error);
export const Weaviate$isApiErroredMigrations = (value) =>
  value instanceof ApiErroredMigrations;
export const Weaviate$ApiErroredMigrations$org_id = (value) => value.org_id;
export const Weaviate$ApiErroredMigrations$0 = (value) => value.org_id;
export const Weaviate$ApiErroredMigrations$error = (value) => value.error;
export const Weaviate$ApiErroredMigrations$1 = (value) => value.error;

export class ApiReturnedMigrations extends $CustomType {
  constructor(org_id, migrations) {
    super();
    this.org_id = org_id;
    this.migrations = migrations;
  }
}
export const Weaviate$ApiReturnedMigrations = (org_id, migrations) =>
  new ApiReturnedMigrations(org_id, migrations);
export const Weaviate$isApiReturnedMigrations = (value) =>
  value instanceof ApiReturnedMigrations;
export const Weaviate$ApiReturnedMigrations$org_id = (value) => value.org_id;
export const Weaviate$ApiReturnedMigrations$0 = (value) => value.org_id;
export const Weaviate$ApiReturnedMigrations$migrations = (value) =>
  value.migrations;
export const Weaviate$ApiReturnedMigrations$1 = (value) => value.migrations;

export class ApiReturnedCollections extends $CustomType {
  constructor(org_id, collections) {
    super();
    this.org_id = org_id;
    this.collections = collections;
  }
}
export const Weaviate$ApiReturnedCollections = (org_id, collections) =>
  new ApiReturnedCollections(org_id, collections);
export const Weaviate$isApiReturnedCollections = (value) =>
  value instanceof ApiReturnedCollections;
export const Weaviate$ApiReturnedCollections$org_id = (value) => value.org_id;
export const Weaviate$ApiReturnedCollections$0 = (value) => value.org_id;
export const Weaviate$ApiReturnedCollections$collections = (value) =>
  value.collections;
export const Weaviate$ApiReturnedCollections$1 = (value) => value.collections;

export class ApiErroredCollections extends $CustomType {
  constructor(org_id, error) {
    super();
    this.org_id = org_id;
    this.error = error;
  }
}
export const Weaviate$ApiErroredCollections = (org_id, error) =>
  new ApiErroredCollections(org_id, error);
export const Weaviate$isApiErroredCollections = (value) =>
  value instanceof ApiErroredCollections;
export const Weaviate$ApiErroredCollections$org_id = (value) => value.org_id;
export const Weaviate$ApiErroredCollections$0 = (value) => value.org_id;
export const Weaviate$ApiErroredCollections$error = (value) => value.error;
export const Weaviate$ApiErroredCollections$1 = (value) => value.error;

export class UserSubmittedMigration extends $CustomType {
  constructor(org_id) {
    super();
    this.org_id = org_id;
  }
}
export const Weaviate$UserSubmittedMigration = (org_id) =>
  new UserSubmittedMigration(org_id);
export const Weaviate$isUserSubmittedMigration = (value) =>
  value instanceof UserSubmittedMigration;
export const Weaviate$UserSubmittedMigration$org_id = (value) => value.org_id;
export const Weaviate$UserSubmittedMigration$0 = (value) => value.org_id;

export const Weaviate$org_id = (value) => value.org_id;

export class ApiReturnedLabelTranslations extends $CustomType {
  constructor(page) {
    super();
    this.page = page;
  }
}
export const LabelTranslations$ApiReturnedLabelTranslations = (page) =>
  new ApiReturnedLabelTranslations(page);
export const LabelTranslations$isApiReturnedLabelTranslations = (value) =>
  value instanceof ApiReturnedLabelTranslations;
export const LabelTranslations$ApiReturnedLabelTranslations$page = (value) =>
  value.page;
export const LabelTranslations$ApiReturnedLabelTranslations$0 = (value) =>
  value.page;

export class UserRequestedLabelTranslationsPage extends $CustomType {
  constructor(page_index) {
    super();
    this.page_index = page_index;
  }
}
export const LabelTranslations$UserRequestedLabelTranslationsPage = (page_index) =>
  new UserRequestedLabelTranslationsPage(page_index);
export const LabelTranslations$isUserRequestedLabelTranslationsPage = (value) =>
  value instanceof UserRequestedLabelTranslationsPage;
export const LabelTranslations$UserRequestedLabelTranslationsPage$page_index = (value) =>
  value.page_index;
export const LabelTranslations$UserRequestedLabelTranslationsPage$0 = (value) =>
  value.page_index;

export class UserRequestedLabelTranslationsSearch extends $CustomType {
  constructor(search) {
    super();
    this.search = search;
  }
}
export const LabelTranslations$UserRequestedLabelTranslationsSearch = (search) =>
  new UserRequestedLabelTranslationsSearch(search);
export const LabelTranslations$isUserRequestedLabelTranslationsSearch = (value) =>
  value instanceof UserRequestedLabelTranslationsSearch;
export const LabelTranslations$UserRequestedLabelTranslationsSearch$search = (value) =>
  value.search;
export const LabelTranslations$UserRequestedLabelTranslationsSearch$0 = (value) =>
  value.search;

export class UserRequestedLabelTranslationsLanguageFilter extends $CustomType {
  constructor(language) {
    super();
    this.language = language;
  }
}
export const LabelTranslations$UserRequestedLabelTranslationsLanguageFilter = (language) =>
  new UserRequestedLabelTranslationsLanguageFilter(language);
export const LabelTranslations$isUserRequestedLabelTranslationsLanguageFilter = (value) =>
  value instanceof UserRequestedLabelTranslationsLanguageFilter;
export const LabelTranslations$UserRequestedLabelTranslationsLanguageFilter$language = (value) =>
  value.language;
export const LabelTranslations$UserRequestedLabelTranslationsLanguageFilter$0 = (value) =>
  value.language;

export class UserRequestedLabelTranslationsSort extends $CustomType {
  constructor(sort) {
    super();
    this.sort = sort;
  }
}
export const LabelTranslations$UserRequestedLabelTranslationsSort = (sort) =>
  new UserRequestedLabelTranslationsSort(sort);
export const LabelTranslations$isUserRequestedLabelTranslationsSort = (value) =>
  value instanceof UserRequestedLabelTranslationsSort;
export const LabelTranslations$UserRequestedLabelTranslationsSort$sort = (value) =>
  value.sort;
export const LabelTranslations$UserRequestedLabelTranslationsSort$0 = (value) =>
  value.sort;

export class UserRequestedDeleteTranslation extends $CustomType {
  constructor(id, version) {
    super();
    this.id = id;
    this.version = version;
  }
}
export const LabelTranslations$UserRequestedDeleteTranslation = (id, version) =>
  new UserRequestedDeleteTranslation(id, version);
export const LabelTranslations$isUserRequestedDeleteTranslation = (value) =>
  value instanceof UserRequestedDeleteTranslation;
export const LabelTranslations$UserRequestedDeleteTranslation$id = (value) =>
  value.id;
export const LabelTranslations$UserRequestedDeleteTranslation$0 = (value) =>
  value.id;
export const LabelTranslations$UserRequestedDeleteTranslation$version = (value) =>
  value.version;
export const LabelTranslations$UserRequestedDeleteTranslation$1 = (value) =>
  value.version;

export class ApiDeletedTranslation extends $CustomType {
  constructor(id, version) {
    super();
    this.id = id;
    this.version = version;
  }
}
export const LabelTranslations$ApiDeletedTranslation = (id, version) =>
  new ApiDeletedTranslation(id, version);
export const LabelTranslations$isApiDeletedTranslation = (value) =>
  value instanceof ApiDeletedTranslation;
export const LabelTranslations$ApiDeletedTranslation$id = (value) => value.id;
export const LabelTranslations$ApiDeletedTranslation$0 = (value) => value.id;
export const LabelTranslations$ApiDeletedTranslation$version = (value) =>
  value.version;
export const LabelTranslations$ApiDeletedTranslation$1 = (value) =>
  value.version;

export class UserRequestedDeleteLabelTranslations extends $CustomType {
  constructor(target_id) {
    super();
    this.target_id = target_id;
  }
}
export const LabelTranslations$UserRequestedDeleteLabelTranslations = (target_id) =>
  new UserRequestedDeleteLabelTranslations(target_id);
export const LabelTranslations$isUserRequestedDeleteLabelTranslations = (value) =>
  value instanceof UserRequestedDeleteLabelTranslations;
export const LabelTranslations$UserRequestedDeleteLabelTranslations$target_id = (value) =>
  value.target_id;
export const LabelTranslations$UserRequestedDeleteLabelTranslations$0 = (value) =>
  value.target_id;

export class ApiDeletedLabelTranslations extends $CustomType {
  constructor(target_id, deleted) {
    super();
    this.target_id = target_id;
    this.deleted = deleted;
  }
}
export const LabelTranslations$ApiDeletedLabelTranslations = (target_id, deleted) =>
  new ApiDeletedLabelTranslations(target_id, deleted);
export const LabelTranslations$isApiDeletedLabelTranslations = (value) =>
  value instanceof ApiDeletedLabelTranslations;
export const LabelTranslations$ApiDeletedLabelTranslations$target_id = (value) =>
  value.target_id;
export const LabelTranslations$ApiDeletedLabelTranslations$0 = (value) =>
  value.target_id;
export const LabelTranslations$ApiDeletedLabelTranslations$deleted = (value) =>
  value.deleted;
export const LabelTranslations$ApiDeletedLabelTranslations$1 = (value) =>
  value.deleted;

export class UserRequestedDeleteAllLabelTranslations extends $CustomType {}
export const LabelTranslations$UserRequestedDeleteAllLabelTranslations = () =>
  new UserRequestedDeleteAllLabelTranslations();
export const LabelTranslations$isUserRequestedDeleteAllLabelTranslations = (value) =>
  value instanceof UserRequestedDeleteAllLabelTranslations;

export class ApiDeletedAllLabelTranslations extends $CustomType {
  constructor(deleted) {
    super();
    this.deleted = deleted;
  }
}
export const LabelTranslations$ApiDeletedAllLabelTranslations = (deleted) =>
  new ApiDeletedAllLabelTranslations(deleted);
export const LabelTranslations$isApiDeletedAllLabelTranslations = (value) =>
  value instanceof ApiDeletedAllLabelTranslations;
export const LabelTranslations$ApiDeletedAllLabelTranslations$deleted = (value) =>
  value.deleted;
export const LabelTranslations$ApiDeletedAllLabelTranslations$0 = (value) =>
  value.deleted;

export class ApiDeletedMaintenance extends $CustomType {
  constructor(org_id) {
    super();
    this.org_id = org_id;
  }
}
export const MaintenanceMode$ApiDeletedMaintenance = (org_id) =>
  new ApiDeletedMaintenance(org_id);
export const MaintenanceMode$isApiDeletedMaintenance = (value) =>
  value instanceof ApiDeletedMaintenance;
export const MaintenanceMode$ApiDeletedMaintenance$org_id = (value) =>
  value.org_id;
export const MaintenanceMode$ApiDeletedMaintenance$0 = (value) => value.org_id;

export class ApiReturnedFrozen extends $CustomType {
  constructor(frozen) {
    super();
    this.frozen = frozen;
  }
}
export const MaintenanceMode$ApiReturnedFrozen = (frozen) =>
  new ApiReturnedFrozen(frozen);
export const MaintenanceMode$isApiReturnedFrozen = (value) =>
  value instanceof ApiReturnedFrozen;
export const MaintenanceMode$ApiReturnedFrozen$frozen = (value) => value.frozen;
export const MaintenanceMode$ApiReturnedFrozen$0 = (value) => value.frozen;

export class ApiReturnedMaintenances extends $CustomType {
  constructor(maintenances) {
    super();
    this.maintenances = maintenances;
  }
}
export const MaintenanceMode$ApiReturnedMaintenances = (maintenances) =>
  new ApiReturnedMaintenances(maintenances);
export const MaintenanceMode$isApiReturnedMaintenances = (value) =>
  value instanceof ApiReturnedMaintenances;
export const MaintenanceMode$ApiReturnedMaintenances$maintenances = (value) =>
  value.maintenances;
export const MaintenanceMode$ApiReturnedMaintenances$0 = (value) =>
  value.maintenances;

export class UserClickedAddDuration extends $CustomType {
  constructor(duration) {
    super();
    this.duration = duration;
  }
}
export const MaintenanceMode$UserClickedAddDuration = (duration) =>
  new UserClickedAddDuration(duration);
export const MaintenanceMode$isUserClickedAddDuration = (value) =>
  value instanceof UserClickedAddDuration;
export const MaintenanceMode$UserClickedAddDuration$duration = (value) =>
  value.duration;
export const MaintenanceMode$UserClickedAddDuration$0 = (value) =>
  value.duration;

export class UserEditedFromInput extends $CustomType {
  constructor(from) {
    super();
    this.from = from;
  }
}
export const MaintenanceMode$UserEditedFromInput = (from) =>
  new UserEditedFromInput(from);
export const MaintenanceMode$isUserEditedFromInput = (value) =>
  value instanceof UserEditedFromInput;
export const MaintenanceMode$UserEditedFromInput$from = (value) => value.from;
export const MaintenanceMode$UserEditedFromInput$0 = (value) => value.from;

export class UserEditedOrganizationInput extends $CustomType {
  constructor(organization) {
    super();
    this.organization = organization;
  }
}
export const MaintenanceMode$UserEditedOrganizationInput = (organization) =>
  new UserEditedOrganizationInput(organization);
export const MaintenanceMode$isUserEditedOrganizationInput = (value) =>
  value instanceof UserEditedOrganizationInput;
export const MaintenanceMode$UserEditedOrganizationInput$organization = (value) =>
  value.organization;
export const MaintenanceMode$UserEditedOrganizationInput$0 = (value) =>
  value.organization;

export class UserEditedToInput extends $CustomType {
  constructor(to) {
    super();
    this.to = to;
  }
}
export const MaintenanceMode$UserEditedToInput = (to) =>
  new UserEditedToInput(to);
export const MaintenanceMode$isUserEditedToInput = (value) =>
  value instanceof UserEditedToInput;
export const MaintenanceMode$UserEditedToInput$to = (value) => value.to;
export const MaintenanceMode$UserEditedToInput$0 = (value) => value.to;

export class UserResumedMaintenance extends $CustomType {
  constructor(org_id) {
    super();
    this.org_id = org_id;
  }
}
export const MaintenanceMode$UserResumedMaintenance = (org_id) =>
  new UserResumedMaintenance(org_id);
export const MaintenanceMode$isUserResumedMaintenance = (value) =>
  value instanceof UserResumedMaintenance;
export const MaintenanceMode$UserResumedMaintenance$org_id = (value) =>
  value.org_id;
export const MaintenanceMode$UserResumedMaintenance$0 = (value) => value.org_id;

export class UserSubmittedMaintenance extends $CustomType {}
export const MaintenanceMode$UserSubmittedMaintenance = () =>
  new UserSubmittedMaintenance();
export const MaintenanceMode$isUserSubmittedMaintenance = (value) =>
  value instanceof UserSubmittedMaintenance;

export class UserToggledAll extends $CustomType {
  constructor(toggled) {
    super();
    this.toggled = toggled;
  }
}
export const MaintenanceMode$UserToggledAll = (toggled) =>
  new UserToggledAll(toggled);
export const MaintenanceMode$isUserToggledAll = (value) =>
  value instanceof UserToggledAll;
export const MaintenanceMode$UserToggledAll$toggled = (value) => value.toggled;
export const MaintenanceMode$UserToggledAll$0 = (value) => value.toggled;

export class ApiReturnedDataSource extends $CustomType {
  constructor(page, source) {
    super();
    this.page = page;
    this.source = source;
  }
}
export const DataSources$ApiReturnedDataSource = (page, source) =>
  new ApiReturnedDataSource(page, source);
export const DataSources$isApiReturnedDataSource = (value) =>
  value instanceof ApiReturnedDataSource;
export const DataSources$ApiReturnedDataSource$page = (value) => value.page;
export const DataSources$ApiReturnedDataSource$0 = (value) => value.page;
export const DataSources$ApiReturnedDataSource$source = (value) => value.source;
export const DataSources$ApiReturnedDataSource$1 = (value) => value.source;

export class ApiStartedLoadingDataSources extends $CustomType {
  constructor(org_id, page) {
    super();
    this.org_id = org_id;
    this.page = page;
  }
}
export const DataSources$ApiStartedLoadingDataSources = (org_id, page) =>
  new ApiStartedLoadingDataSources(org_id, page);
export const DataSources$isApiStartedLoadingDataSources = (value) =>
  value instanceof ApiStartedLoadingDataSources;
export const DataSources$ApiStartedLoadingDataSources$org_id = (value) =>
  value.org_id;
export const DataSources$ApiStartedLoadingDataSources$0 = (value) =>
  value.org_id;
export const DataSources$ApiStartedLoadingDataSources$page = (value) =>
  value.page;
export const DataSources$ApiStartedLoadingDataSources$1 = (value) => value.page;

export class ApiErroredDataSources extends $CustomType {
  constructor(org_id, page, error) {
    super();
    this.org_id = org_id;
    this.page = page;
    this.error = error;
  }
}
export const DataSources$ApiErroredDataSources = (org_id, page, error) =>
  new ApiErroredDataSources(org_id, page, error);
export const DataSources$isApiErroredDataSources = (value) =>
  value instanceof ApiErroredDataSources;
export const DataSources$ApiErroredDataSources$org_id = (value) => value.org_id;
export const DataSources$ApiErroredDataSources$0 = (value) => value.org_id;
export const DataSources$ApiErroredDataSources$page = (value) => value.page;
export const DataSources$ApiErroredDataSources$1 = (value) => value.page;
export const DataSources$ApiErroredDataSources$error = (value) => value.error;
export const DataSources$ApiErroredDataSources$2 = (value) => value.error;

export class ApiReturnedDataSources extends $CustomType {
  constructor(org_id, page, total, sources) {
    super();
    this.org_id = org_id;
    this.page = page;
    this.total = total;
    this.sources = sources;
  }
}
export const DataSources$ApiReturnedDataSources = (org_id, page, total, sources) =>
  new ApiReturnedDataSources(org_id, page, total, sources);
export const DataSources$isApiReturnedDataSources = (value) =>
  value instanceof ApiReturnedDataSources;
export const DataSources$ApiReturnedDataSources$org_id = (value) =>
  value.org_id;
export const DataSources$ApiReturnedDataSources$0 = (value) => value.org_id;
export const DataSources$ApiReturnedDataSources$page = (value) => value.page;
export const DataSources$ApiReturnedDataSources$1 = (value) => value.page;
export const DataSources$ApiReturnedDataSources$total = (value) => value.total;
export const DataSources$ApiReturnedDataSources$2 = (value) => value.total;
export const DataSources$ApiReturnedDataSources$sources = (value) =>
  value.sources;
export const DataSources$ApiReturnedDataSources$3 = (value) => value.sources;

export class ApiFetchedDataPoints extends $CustomType {
  constructor(source_id, data_points) {
    super();
    this.source_id = source_id;
    this.data_points = data_points;
  }
}
export const ContentLibrary$ApiFetchedDataPoints = (source_id, data_points) =>
  new ApiFetchedDataPoints(source_id, data_points);
export const ContentLibrary$isApiFetchedDataPoints = (value) =>
  value instanceof ApiFetchedDataPoints;
export const ContentLibrary$ApiFetchedDataPoints$source_id = (value) =>
  value.source_id;
export const ContentLibrary$ApiFetchedDataPoints$0 = (value) => value.source_id;
export const ContentLibrary$ApiFetchedDataPoints$data_points = (value) =>
  value.data_points;
export const ContentLibrary$ApiFetchedDataPoints$1 = (value) =>
  value.data_points;

export class ApiReturnedSource extends $CustomType {
  constructor(source) {
    super();
    this.source = source;
  }
}
export const ContentLibrary$ApiReturnedSource = (source) =>
  new ApiReturnedSource(source);
export const ContentLibrary$isApiReturnedSource = (value) =>
  value instanceof ApiReturnedSource;
export const ContentLibrary$ApiReturnedSource$source = (value) => value.source;
export const ContentLibrary$ApiReturnedSource$0 = (value) => value.source;

export class ApiReturnedSources extends $CustomType {
  constructor(sources) {
    super();
    this.sources = sources;
  }
}
export const ContentLibrary$ApiReturnedSources = (sources) =>
  new ApiReturnedSources(sources);
export const ContentLibrary$isApiReturnedSources = (value) =>
  value instanceof ApiReturnedSources;
export const ContentLibrary$ApiReturnedSources$sources = (value) =>
  value.sources;
export const ContentLibrary$ApiReturnedSources$0 = (value) => value.sources;

export class SwitchedVisbility extends $CustomType {
  constructor(source_id) {
    super();
    this.source_id = source_id;
  }
}
export const ContentLibrary$SwitchedVisbility = (source_id) =>
  new SwitchedVisbility(source_id);
export const ContentLibrary$isSwitchedVisbility = (value) =>
  value instanceof SwitchedVisbility;
export const ContentLibrary$SwitchedVisbility$source_id = (value) =>
  value.source_id;
export const ContentLibrary$SwitchedVisbility$0 = (value) => value.source_id;

export class UserAssignedStatus extends $CustomType {
  constructor(status) {
    super();
    this.status = status;
  }
}
export const ContentLibrary$UserAssignedStatus = (status) =>
  new UserAssignedStatus(status);
export const ContentLibrary$isUserAssignedStatus = (value) =>
  value instanceof UserAssignedStatus;
export const ContentLibrary$UserAssignedStatus$status = (value) => value.status;
export const ContentLibrary$UserAssignedStatus$0 = (value) => value.status;

export class UserClickedGlobalCheckbox extends $CustomType {
  constructor(all_selected, sources) {
    super();
    this.all_selected = all_selected;
    this.sources = sources;
  }
}
export const ContentLibrary$UserClickedGlobalCheckbox = (all_selected, sources) =>
  new UserClickedGlobalCheckbox(all_selected, sources);
export const ContentLibrary$isUserClickedGlobalCheckbox = (value) =>
  value instanceof UserClickedGlobalCheckbox;
export const ContentLibrary$UserClickedGlobalCheckbox$all_selected = (value) =>
  value.all_selected;
export const ContentLibrary$UserClickedGlobalCheckbox$0 = (value) =>
  value.all_selected;
export const ContentLibrary$UserClickedGlobalCheckbox$sources = (value) =>
  value.sources;
export const ContentLibrary$UserClickedGlobalCheckbox$1 = (value) =>
  value.sources;

export class UserClickedOnFetchDataPoints extends $CustomType {
  constructor(source_id) {
    super();
    this.source_id = source_id;
  }
}
export const ContentLibrary$UserClickedOnFetchDataPoints = (source_id) =>
  new UserClickedOnFetchDataPoints(source_id);
export const ContentLibrary$isUserClickedOnFetchDataPoints = (value) =>
  value instanceof UserClickedOnFetchDataPoints;
export const ContentLibrary$UserClickedOnFetchDataPoints$source_id = (value) =>
  value.source_id;
export const ContentLibrary$UserClickedOnFetchDataPoints$0 = (value) =>
  value.source_id;

export class UserClickedOnSourceInspect extends $CustomType {
  constructor(source_id) {
    super();
    this.source_id = source_id;
  }
}
export const ContentLibrary$UserClickedOnSourceInspect = (source_id) =>
  new UserClickedOnSourceInspect(source_id);
export const ContentLibrary$isUserClickedOnSourceInspect = (value) =>
  value instanceof UserClickedOnSourceInspect;
export const ContentLibrary$UserClickedOnSourceInspect$source_id = (value) =>
  value.source_id;
export const ContentLibrary$UserClickedOnSourceInspect$0 = (value) =>
  value.source_id;

export class UserClickedOnSourcePreview extends $CustomType {
  constructor(source_id) {
    super();
    this.source_id = source_id;
  }
}
export const ContentLibrary$UserClickedOnSourcePreview = (source_id) =>
  new UserClickedOnSourcePreview(source_id);
export const ContentLibrary$isUserClickedOnSourcePreview = (value) =>
  value instanceof UserClickedOnSourcePreview;
export const ContentLibrary$UserClickedOnSourcePreview$source_id = (value) =>
  value.source_id;
export const ContentLibrary$UserClickedOnSourcePreview$0 = (value) =>
  value.source_id;

export class UserSelectedSource extends $CustomType {
  constructor(id, checked) {
    super();
    this.id = id;
    this.checked = checked;
  }
}
export const ContentLibrary$UserSelectedSource = (id, checked) =>
  new UserSelectedSource(id, checked);
export const ContentLibrary$isUserSelectedSource = (value) =>
  value instanceof UserSelectedSource;
export const ContentLibrary$UserSelectedSource$id = (value) => value.id;
export const ContentLibrary$UserSelectedSource$0 = (value) => value.id;
export const ContentLibrary$UserSelectedSource$checked = (value) =>
  value.checked;
export const ContentLibrary$UserSelectedSource$1 = (value) => value.checked;

export class UserToggledChangeStatusPopup extends $CustomType {}
export const ContentLibrary$UserToggledChangeStatusPopup = () =>
  new UserToggledChangeStatusPopup();
export const ContentLibrary$isUserToggledChangeStatusPopup = (value) =>
  value instanceof UserToggledChangeStatusPopup;

export class ApiStartedLoadingAiConfig extends $CustomType {
  constructor(org_id) {
    super();
    this.org_id = org_id;
  }
}
export const AiConfig$ApiStartedLoadingAiConfig = (org_id) =>
  new ApiStartedLoadingAiConfig(org_id);
export const AiConfig$isApiStartedLoadingAiConfig = (value) =>
  value instanceof ApiStartedLoadingAiConfig;
export const AiConfig$ApiStartedLoadingAiConfig$org_id = (value) =>
  value.org_id;
export const AiConfig$ApiStartedLoadingAiConfig$0 = (value) => value.org_id;

export class ApiReturnedAiConfig extends $CustomType {
  constructor(org_id, value) {
    super();
    this.org_id = org_id;
    this.value = value;
  }
}
export const AiConfig$ApiReturnedAiConfig = (org_id, value) =>
  new ApiReturnedAiConfig(org_id, value);
export const AiConfig$isApiReturnedAiConfig = (value) =>
  value instanceof ApiReturnedAiConfig;
export const AiConfig$ApiReturnedAiConfig$org_id = (value) => value.org_id;
export const AiConfig$ApiReturnedAiConfig$0 = (value) => value.org_id;
export const AiConfig$ApiReturnedAiConfig$value = (value) => value.value;
export const AiConfig$ApiReturnedAiConfig$1 = (value) => value.value;

export class ApiReturnedAiConfigs extends $CustomType {
  constructor(ai_configs) {
    super();
    this.ai_configs = ai_configs;
  }
}
export const AiConfig$ApiReturnedAiConfigs = (ai_configs) =>
  new ApiReturnedAiConfigs(ai_configs);
export const AiConfig$isApiReturnedAiConfigs = (value) =>
  value instanceof ApiReturnedAiConfigs;
export const AiConfig$ApiReturnedAiConfigs$ai_configs = (value) =>
  value.ai_configs;
export const AiConfig$ApiReturnedAiConfigs$0 = (value) => value.ai_configs;

export class ApiSavedAiConfig extends $CustomType {
  constructor(ai_config) {
    super();
    this.ai_config = ai_config;
  }
}
export const AiConfig$ApiSavedAiConfig = (ai_config) =>
  new ApiSavedAiConfig(ai_config);
export const AiConfig$isApiSavedAiConfig = (value) =>
  value instanceof ApiSavedAiConfig;
export const AiConfig$ApiSavedAiConfig$ai_config = (value) => value.ai_config;
export const AiConfig$ApiSavedAiConfig$0 = (value) => value.ai_config;

export class UserSubmittedWebsitePromptConfig extends $CustomType {
  constructor(value) {
    super();
    this.value = value;
  }
}
export const AiConfig$UserSubmittedWebsitePromptConfig = (value) =>
  new UserSubmittedWebsitePromptConfig(value);
export const AiConfig$isUserSubmittedWebsitePromptConfig = (value) =>
  value instanceof UserSubmittedWebsitePromptConfig;
export const AiConfig$UserSubmittedWebsitePromptConfig$value = (value) =>
  value.value;
export const AiConfig$UserSubmittedWebsitePromptConfig$0 = (value) =>
  value.value;

export class ApiReturnedOrganizations extends $CustomType {
  constructor(total, organizations) {
    super();
    this.total = total;
    this.organizations = organizations;
  }
}
export const Organizations$ApiReturnedOrganizations = (total, organizations) =>
  new ApiReturnedOrganizations(total, organizations);
export const Organizations$isApiReturnedOrganizations = (value) =>
  value instanceof ApiReturnedOrganizations;
export const Organizations$ApiReturnedOrganizations$total = (value) =>
  value.total;
export const Organizations$ApiReturnedOrganizations$0 = (value) => value.total;
export const Organizations$ApiReturnedOrganizations$organizations = (value) =>
  value.organizations;
export const Organizations$ApiReturnedOrganizations$1 = (value) =>
  value.organizations;

export class ApiStartedLoadingOrganizations extends $CustomType {}
export const Organizations$ApiStartedLoadingOrganizations = () =>
  new ApiStartedLoadingOrganizations();
export const Organizations$isApiStartedLoadingOrganizations = (value) =>
  value instanceof ApiStartedLoadingOrganizations;

export class ApiErroredOrganizations extends $CustomType {
  constructor(content) {
    super();
    this.content = content;
  }
}
export const Organizations$ApiErroredOrganizations = (content) =>
  new ApiErroredOrganizations(content);
export const Organizations$isApiErroredOrganizations = (value) =>
  value instanceof ApiErroredOrganizations;
export const Organizations$ApiErroredOrganizations$content = (value) =>
  value.content;
export const Organizations$ApiErroredOrganizations$0 = (value) => value.content;

export class ApiReturnedOrganizationsUsers extends $CustomType {
  constructor(org_id, users) {
    super();
    this.org_id = org_id;
    this.users = users;
  }
}
export const Organizations$ApiReturnedOrganizationsUsers = (org_id, users) =>
  new ApiReturnedOrganizationsUsers(org_id, users);
export const Organizations$isApiReturnedOrganizationsUsers = (value) =>
  value instanceof ApiReturnedOrganizationsUsers;
export const Organizations$ApiReturnedOrganizationsUsers$org_id = (value) =>
  value.org_id;
export const Organizations$ApiReturnedOrganizationsUsers$0 = (value) =>
  value.org_id;
export const Organizations$ApiReturnedOrganizationsUsers$users = (value) =>
  value.users;
export const Organizations$ApiReturnedOrganizationsUsers$1 = (value) =>
  value.users;

export class ApiStartedLoadingOrganizationsUsers extends $CustomType {
  constructor(org_id) {
    super();
    this.org_id = org_id;
  }
}
export const Organizations$ApiStartedLoadingOrganizationsUsers = (org_id) =>
  new ApiStartedLoadingOrganizationsUsers(org_id);
export const Organizations$isApiStartedLoadingOrganizationsUsers = (value) =>
  value instanceof ApiStartedLoadingOrganizationsUsers;
export const Organizations$ApiStartedLoadingOrganizationsUsers$org_id = (value) =>
  value.org_id;
export const Organizations$ApiStartedLoadingOrganizationsUsers$0 = (value) =>
  value.org_id;

export class ApiErroredOrganizationsUsers extends $CustomType {
  constructor(org_id, content) {
    super();
    this.org_id = org_id;
    this.content = content;
  }
}
export const Organizations$ApiErroredOrganizationsUsers = (org_id, content) =>
  new ApiErroredOrganizationsUsers(org_id, content);
export const Organizations$isApiErroredOrganizationsUsers = (value) =>
  value instanceof ApiErroredOrganizationsUsers;
export const Organizations$ApiErroredOrganizationsUsers$org_id = (value) =>
  value.org_id;
export const Organizations$ApiErroredOrganizationsUsers$0 = (value) =>
  value.org_id;
export const Organizations$ApiErroredOrganizationsUsers$content = (value) =>
  value.content;
export const Organizations$ApiErroredOrganizationsUsers$1 = (value) =>
  value.content;

export class ApiReturnedOrganizationsTags extends $CustomType {
  constructor(org_id, tags) {
    super();
    this.org_id = org_id;
    this.tags = tags;
  }
}
export const Organizations$ApiReturnedOrganizationsTags = (org_id, tags) =>
  new ApiReturnedOrganizationsTags(org_id, tags);
export const Organizations$isApiReturnedOrganizationsTags = (value) =>
  value instanceof ApiReturnedOrganizationsTags;
export const Organizations$ApiReturnedOrganizationsTags$org_id = (value) =>
  value.org_id;
export const Organizations$ApiReturnedOrganizationsTags$0 = (value) =>
  value.org_id;
export const Organizations$ApiReturnedOrganizationsTags$tags = (value) =>
  value.tags;
export const Organizations$ApiReturnedOrganizationsTags$1 = (value) =>
  value.tags;

export class ApiStartedLoadingOrganizationsTags extends $CustomType {
  constructor(org_id) {
    super();
    this.org_id = org_id;
  }
}
export const Organizations$ApiStartedLoadingOrganizationsTags = (org_id) =>
  new ApiStartedLoadingOrganizationsTags(org_id);
export const Organizations$isApiStartedLoadingOrganizationsTags = (value) =>
  value instanceof ApiStartedLoadingOrganizationsTags;
export const Organizations$ApiStartedLoadingOrganizationsTags$org_id = (value) =>
  value.org_id;
export const Organizations$ApiStartedLoadingOrganizationsTags$0 = (value) =>
  value.org_id;

export class ApiErroredOrganizationsTags extends $CustomType {
  constructor(org_id, content) {
    super();
    this.org_id = org_id;
    this.content = content;
  }
}
export const Organizations$ApiErroredOrganizationsTags = (org_id, content) =>
  new ApiErroredOrganizationsTags(org_id, content);
export const Organizations$isApiErroredOrganizationsTags = (value) =>
  value instanceof ApiErroredOrganizationsTags;
export const Organizations$ApiErroredOrganizationsTags$org_id = (value) =>
  value.org_id;
export const Organizations$ApiErroredOrganizationsTags$0 = (value) =>
  value.org_id;
export const Organizations$ApiErroredOrganizationsTags$content = (value) =>
  value.content;
export const Organizations$ApiErroredOrganizationsTags$1 = (value) =>
  value.content;

export class ApiReturnedOrganizationsConnections extends $CustomType {
  constructor(org_id, connections) {
    super();
    this.org_id = org_id;
    this.connections = connections;
  }
}
export const Organizations$ApiReturnedOrganizationsConnections = (org_id, connections) =>
  new ApiReturnedOrganizationsConnections(org_id, connections);
export const Organizations$isApiReturnedOrganizationsConnections = (value) =>
  value instanceof ApiReturnedOrganizationsConnections;
export const Organizations$ApiReturnedOrganizationsConnections$org_id = (value) =>
  value.org_id;
export const Organizations$ApiReturnedOrganizationsConnections$0 = (value) =>
  value.org_id;
export const Organizations$ApiReturnedOrganizationsConnections$connections = (value) =>
  value.connections;
export const Organizations$ApiReturnedOrganizationsConnections$1 = (value) =>
  value.connections;

export class ApiStartedLoadingOrganizationsConnections extends $CustomType {
  constructor(org_id) {
    super();
    this.org_id = org_id;
  }
}
export const Organizations$ApiStartedLoadingOrganizationsConnections = (org_id) =>
  new ApiStartedLoadingOrganizationsConnections(org_id);
export const Organizations$isApiStartedLoadingOrganizationsConnections = (value) =>
  value instanceof ApiStartedLoadingOrganizationsConnections;
export const Organizations$ApiStartedLoadingOrganizationsConnections$org_id = (value) =>
  value.org_id;
export const Organizations$ApiStartedLoadingOrganizationsConnections$0 = (value) =>
  value.org_id;

export class ApiErroredOrganizationsConnections extends $CustomType {
  constructor(org_id, content) {
    super();
    this.org_id = org_id;
    this.content = content;
  }
}
export const Organizations$ApiErroredOrganizationsConnections = (org_id, content) =>
  new ApiErroredOrganizationsConnections(org_id, content);
export const Organizations$isApiErroredOrganizationsConnections = (value) =>
  value instanceof ApiErroredOrganizationsConnections;
export const Organizations$ApiErroredOrganizationsConnections$org_id = (value) =>
  value.org_id;
export const Organizations$ApiErroredOrganizationsConnections$0 = (value) =>
  value.org_id;
export const Organizations$ApiErroredOrganizationsConnections$content = (value) =>
  value.content;
export const Organizations$ApiErroredOrganizationsConnections$1 = (value) =>
  value.content;

export class ApiStartedLoadingOrganizationsInvitations extends $CustomType {
  constructor(org_id) {
    super();
    this.org_id = org_id;
  }
}
export const Organizations$ApiStartedLoadingOrganizationsInvitations = (org_id) =>
  new ApiStartedLoadingOrganizationsInvitations(org_id);
export const Organizations$isApiStartedLoadingOrganizationsInvitations = (value) =>
  value instanceof ApiStartedLoadingOrganizationsInvitations;
export const Organizations$ApiStartedLoadingOrganizationsInvitations$org_id = (value) =>
  value.org_id;
export const Organizations$ApiStartedLoadingOrganizationsInvitations$0 = (value) =>
  value.org_id;

export class ApiErroredOrganizationsInvitations extends $CustomType {
  constructor(org_id, content) {
    super();
    this.org_id = org_id;
    this.content = content;
  }
}
export const Organizations$ApiErroredOrganizationsInvitations = (org_id, content) =>
  new ApiErroredOrganizationsInvitations(org_id, content);
export const Organizations$isApiErroredOrganizationsInvitations = (value) =>
  value instanceof ApiErroredOrganizationsInvitations;
export const Organizations$ApiErroredOrganizationsInvitations$org_id = (value) =>
  value.org_id;
export const Organizations$ApiErroredOrganizationsInvitations$0 = (value) =>
  value.org_id;
export const Organizations$ApiErroredOrganizationsInvitations$content = (value) =>
  value.content;
export const Organizations$ApiErroredOrganizationsInvitations$1 = (value) =>
  value.content;

export class ApiReturnedOrganizationsInvitations extends $CustomType {
  constructor(org_id, invitations) {
    super();
    this.org_id = org_id;
    this.invitations = invitations;
  }
}
export const Organizations$ApiReturnedOrganizationsInvitations = (org_id, invitations) =>
  new ApiReturnedOrganizationsInvitations(org_id, invitations);
export const Organizations$isApiReturnedOrganizationsInvitations = (value) =>
  value instanceof ApiReturnedOrganizationsInvitations;
export const Organizations$ApiReturnedOrganizationsInvitations$org_id = (value) =>
  value.org_id;
export const Organizations$ApiReturnedOrganizationsInvitations$0 = (value) =>
  value.org_id;
export const Organizations$ApiReturnedOrganizationsInvitations$invitations = (value) =>
  value.invitations;
export const Organizations$ApiReturnedOrganizationsInvitations$1 = (value) =>
  value.invitations;

export class ApiReturnedSocketsConnections extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}
export const Organizations$ApiReturnedSocketsConnections = ($0) =>
  new ApiReturnedSocketsConnections($0);
export const Organizations$isApiReturnedSocketsConnections = (value) =>
  value instanceof ApiReturnedSocketsConnections;
export const Organizations$ApiReturnedSocketsConnections$0 = (value) =>
  value[0];

export class ApiStartedLoadingQualificationMatrix extends $CustomType {
  constructor(org_id) {
    super();
    this.org_id = org_id;
  }
}
export const OrganizationSetup$ApiStartedLoadingQualificationMatrix = (org_id) =>
  new ApiStartedLoadingQualificationMatrix(org_id);
export const OrganizationSetup$isApiStartedLoadingQualificationMatrix = (value) =>
  value instanceof ApiStartedLoadingQualificationMatrix;
export const OrganizationSetup$ApiStartedLoadingQualificationMatrix$org_id = (value) =>
  value.org_id;
export const OrganizationSetup$ApiStartedLoadingQualificationMatrix$0 = (value) =>
  value.org_id;

export class ApiReturnedQualificationMatrix extends $CustomType {
  constructor(org_id, qm_rows) {
    super();
    this.org_id = org_id;
    this.qm_rows = qm_rows;
  }
}
export const OrganizationSetup$ApiReturnedQualificationMatrix = (org_id, qm_rows) =>
  new ApiReturnedQualificationMatrix(org_id, qm_rows);
export const OrganizationSetup$isApiReturnedQualificationMatrix = (value) =>
  value instanceof ApiReturnedQualificationMatrix;
export const OrganizationSetup$ApiReturnedQualificationMatrix$org_id = (value) =>
  value.org_id;
export const OrganizationSetup$ApiReturnedQualificationMatrix$0 = (value) =>
  value.org_id;
export const OrganizationSetup$ApiReturnedQualificationMatrix$qm_rows = (value) =>
  value.qm_rows;
export const OrganizationSetup$ApiReturnedQualificationMatrix$1 = (value) =>
  value.qm_rows;

export class ApiSavedDefaults extends $CustomType {
  constructor(org_id, ai_config, tags, qm_rows) {
    super();
    this.org_id = org_id;
    this.ai_config = ai_config;
    this.tags = tags;
    this.qm_rows = qm_rows;
  }
}
export const OrganizationSetup$ApiSavedDefaults = (org_id, ai_config, tags, qm_rows) =>
  new ApiSavedDefaults(org_id, ai_config, tags, qm_rows);
export const OrganizationSetup$isApiSavedDefaults = (value) =>
  value instanceof ApiSavedDefaults;
export const OrganizationSetup$ApiSavedDefaults$org_id = (value) =>
  value.org_id;
export const OrganizationSetup$ApiSavedDefaults$0 = (value) => value.org_id;
export const OrganizationSetup$ApiSavedDefaults$ai_config = (value) =>
  value.ai_config;
export const OrganizationSetup$ApiSavedDefaults$1 = (value) => value.ai_config;
export const OrganizationSetup$ApiSavedDefaults$tags = (value) => value.tags;
export const OrganizationSetup$ApiSavedDefaults$2 = (value) => value.tags;
export const OrganizationSetup$ApiSavedDefaults$qm_rows = (value) =>
  value.qm_rows;
export const OrganizationSetup$ApiSavedDefaults$3 = (value) => value.qm_rows;

export class UserClickedSetup extends $CustomType {}
export const OrganizationSetup$UserClickedSetup = () => new UserClickedSetup();
export const OrganizationSetup$isUserClickedSetup = (value) =>
  value instanceof UserClickedSetup;

export class UserRemovedTag extends $CustomType {
  constructor(org_id, tag) {
    super();
    this.org_id = org_id;
    this.tag = tag;
  }
}
export const OrganizationSetup$UserRemovedTag = (org_id, tag) =>
  new UserRemovedTag(org_id, tag);
export const OrganizationSetup$isUserRemovedTag = (value) =>
  value instanceof UserRemovedTag;
export const OrganizationSetup$UserRemovedTag$org_id = (value) => value.org_id;
export const OrganizationSetup$UserRemovedTag$0 = (value) => value.org_id;
export const OrganizationSetup$UserRemovedTag$tag = (value) => value.tag;
export const OrganizationSetup$UserRemovedTag$1 = (value) => value.tag;

export class UserUpdatedDashboardOptions extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}
export const Dashboard$UserUpdatedDashboardOptions = ($0) =>
  new UserUpdatedDashboardOptions($0);
export const Dashboard$isUserUpdatedDashboardOptions = (value) =>
  value instanceof UserUpdatedDashboardOptions;
export const Dashboard$UserUpdatedDashboardOptions$0 = (value) => value[0];

export class ApiReturnedAnalytics extends $CustomType {
  constructor(analytics) {
    super();
    this.analytics = analytics;
  }
}
export const Dashboard$ApiReturnedAnalytics = (analytics) =>
  new ApiReturnedAnalytics(analytics);
export const Dashboard$isApiReturnedAnalytics = (value) =>
  value instanceof ApiReturnedAnalytics;
export const Dashboard$ApiReturnedAnalytics$analytics = (value) =>
  value.analytics;
export const Dashboard$ApiReturnedAnalytics$0 = (value) => value.analytics;

export class ApiReturnedMetrics extends $CustomType {
  constructor(group) {
    super();
    this.group = group;
  }
}
export const Dashboard$ApiReturnedMetrics = (group) =>
  new ApiReturnedMetrics(group);
export const Dashboard$isApiReturnedMetrics = (value) =>
  value instanceof ApiReturnedMetrics;
export const Dashboard$ApiReturnedMetrics$group = (value) => value.group;
export const Dashboard$ApiReturnedMetrics$0 = (value) => value.group;

export class ApiReturnedProjects extends $CustomType {
  constructor(projects) {
    super();
    this.projects = projects;
  }
}
export const Project$ApiReturnedProjects = (projects) =>
  new ApiReturnedProjects(projects);
export const Project$isApiReturnedProjects = (value) =>
  value instanceof ApiReturnedProjects;
export const Project$ApiReturnedProjects$projects = (value) => value.projects;
export const Project$ApiReturnedProjects$0 = (value) => value.projects;

export class ApiReturnedProjectsFile extends $CustomType {
  constructor(project_files, project_id) {
    super();
    this.project_files = project_files;
    this.project_id = project_id;
  }
}
export const Project$ApiReturnedProjectsFile = (project_files, project_id) =>
  new ApiReturnedProjectsFile(project_files, project_id);
export const Project$isApiReturnedProjectsFile = (value) =>
  value instanceof ApiReturnedProjectsFile;
export const Project$ApiReturnedProjectsFile$project_files = (value) =>
  value.project_files;
export const Project$ApiReturnedProjectsFile$0 = (value) => value.project_files;
export const Project$ApiReturnedProjectsFile$project_id = (value) =>
  value.project_id;
export const Project$ApiReturnedProjectsFile$1 = (value) => value.project_id;

export class UserSelectedPage extends $CustomType {
  constructor(page_index) {
    super();
    this.page_index = page_index;
  }
}
export const Project$UserSelectedPage = (page_index) =>
  new UserSelectedPage(page_index);
export const Project$isUserSelectedPage = (value) =>
  value instanceof UserSelectedPage;
export const Project$UserSelectedPage$page_index = (value) => value.page_index;
export const Project$UserSelectedPage$0 = (value) => value.page_index;

export class ApiReturnedProposals extends $CustomType {
  constructor(proposals) {
    super();
    this.proposals = proposals;
  }
}
export const Proposal$ApiReturnedProposals = (proposals) =>
  new ApiReturnedProposals(proposals);
export const Proposal$isApiReturnedProposals = (value) =>
  value instanceof ApiReturnedProposals;
export const Proposal$ApiReturnedProposals$proposals = (value) =>
  value.proposals;
export const Proposal$ApiReturnedProposals$0 = (value) => value.proposals;

export class ApiReturnedProposalElements extends $CustomType {
  constructor(proposal_id, elements) {
    super();
    this.proposal_id = proposal_id;
    this.elements = elements;
  }
}
export const Proposal$ApiReturnedProposalElements = (proposal_id, elements) =>
  new ApiReturnedProposalElements(proposal_id, elements);
export const Proposal$isApiReturnedProposalElements = (value) =>
  value instanceof ApiReturnedProposalElements;
export const Proposal$ApiReturnedProposalElements$proposal_id = (value) =>
  value.proposal_id;
export const Proposal$ApiReturnedProposalElements$0 = (value) =>
  value.proposal_id;
export const Proposal$ApiReturnedProposalElements$elements = (value) =>
  value.elements;
export const Proposal$ApiReturnedProposalElements$1 = (value) => value.elements;

export class ApiReturnedAnswers extends $CustomType {
  constructor(proposal_id, answers) {
    super();
    this.proposal_id = proposal_id;
    this.answers = answers;
  }
}
export const Proposal$ApiReturnedAnswers = (proposal_id, answers) =>
  new ApiReturnedAnswers(proposal_id, answers);
export const Proposal$isApiReturnedAnswers = (value) =>
  value instanceof ApiReturnedAnswers;
export const Proposal$ApiReturnedAnswers$proposal_id = (value) =>
  value.proposal_id;
export const Proposal$ApiReturnedAnswers$0 = (value) => value.proposal_id;
export const Proposal$ApiReturnedAnswers$answers = (value) => value.answers;
export const Proposal$ApiReturnedAnswers$1 = (value) => value.answers;

export class ApiReturnedTranslations extends $CustomType {
  constructor(proposal_id, translations) {
    super();
    this.proposal_id = proposal_id;
    this.translations = translations;
  }
}
export const Proposal$ApiReturnedTranslations = (proposal_id, translations) =>
  new ApiReturnedTranslations(proposal_id, translations);
export const Proposal$isApiReturnedTranslations = (value) =>
  value instanceof ApiReturnedTranslations;
export const Proposal$ApiReturnedTranslations$proposal_id = (value) =>
  value.proposal_id;
export const Proposal$ApiReturnedTranslations$0 = (value) => value.proposal_id;
export const Proposal$ApiReturnedTranslations$translations = (value) =>
  value.translations;
export const Proposal$ApiReturnedTranslations$1 = (value) => value.translations;
